/**
 * <header-drawer> — mobile nav. Drill-down navigation (one panel visible at
 * a time) with `inert` toggled on hidden panels so they're unreachable by
 * keyboard/screen reader while off-screen. Pattern adapted from
 * ColoredByte/coloredvision-store's header-drawer.js (see
 * docs/REFERENCE_AUDIT.md) — reimplemented from scratch for this theme.
 */
class HeaderDrawer extends HTMLElement {
  constructor() {
    super();
    this.panelWrap = this.querySelector('[data-trap-focus]');
  }

  connectedCallback() {
    this.querySelectorAll('[data-header-drawer-toggle]').forEach((el) =>
      el.addEventListener('click', () => this.close())
    );
    this.querySelectorAll('[data-drawer-drill]').forEach((btn) =>
      btn.addEventListener('click', () => this.drillInto(btn.dataset.drawerDrill))
    );
    this.querySelectorAll('[data-drawer-back]').forEach((btn) =>
      btn.addEventListener('click', () => this.drillBack())
    );

    document.querySelectorAll('[data-header-drawer-toggle]').forEach((toggle) => {
      if (this.contains(toggle)) return;
      toggle.addEventListener('click', () => this.open());
    });
  }

  open() {
    this.hidden = false;
    document.body.style.overflow = 'hidden';
    document.querySelector('[data-header-drawer-toggle]:not([hidden])')?.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(() => {
      if (window.NantesUtils) {
        this.dataset.trapFocus = 'true';
        window.NantesUtils.trapFocus(this.panelWrap, this.querySelector('.header-drawer__close'));
      }
    });
  }

  close() {
    this.hidden = true;
    this.classList.remove('is-drilled');
    document.body.style.overflow = '';
    document.querySelectorAll('[data-header-drawer-toggle]').forEach((t) => t.setAttribute('aria-expanded', 'false'));
    this.querySelectorAll('[data-drawer-panel][data-level="1"]').forEach((panel) => {
      panel.classList.remove('is-active');
      panel.setAttribute('inert', '');
    });
    window.NantesUtils && window.NantesUtils.removeTrapFocus();
  }

  drillInto(targetId) {
    const target = this.querySelector(`#${targetId}`);
    if (!target) return;
    this.classList.add('is-drilled');
    target.classList.add('is-active');
    target.removeAttribute('inert');
    const back = target.querySelector('[data-drawer-back]');
    back && back.focus();
  }

  drillBack() {
    this.classList.remove('is-drilled');
    this.querySelectorAll('[data-drawer-panel][data-level="1"].is-active').forEach((panel) => {
      panel.classList.remove('is-active');
      panel.setAttribute('inert', '');
    });
  }
}

customElements.define('header-drawer', HeaderDrawer);
